import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// アプリ更新後（再デプロイ後）に、キャッシュされた古いHTMLが存在しない
// JS/CSSチャンクを要求して真っ白になる問題への対策:
// 読み込み失敗を検知したら一度だけ自動リロードして最新バンドルを取得する。
const RELOAD_FLAG = "chunk_reloaded";
const isChunkError = (msg) =>
  /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module|Importing a module script failed|Failed to fetch dynamically/i.test(
    String(msg || "")
  );
const reloadOnce = () => {
  if (!sessionStorage.getItem(RELOAD_FLAG)) {
    sessionStorage.setItem(RELOAD_FLAG, "1");
    window.location.reload();
  }
};
window.addEventListener(
  "error",
  (e) => {
    const t = e && e.target;
    if (t && (t.tagName === "SCRIPT" || t.tagName === "LINK")) {
      reloadOnce();
      return;
    }
    if (isChunkError(e && e.message)) reloadOnce();
  },
  true
);
window.addEventListener("unhandledrejection", (e) => {
  const r = e && e.reason;
  if (isChunkError(r && (r.message || r))) reloadOnce();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// 正常に起動できたらフラグを解除（次回の更新時にも自動リロードが効くように）
setTimeout(() => {
  try {
    sessionStorage.removeItem(RELOAD_FLAG);
  } catch (_) {}
}, 4000);
